import { WorkTimeEntryToCreate } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import { ValidationFn } from '../useValidation';
import { ValidationUtils } from '../ValidationUtils';
import { validateWorkTimeEntryBreaks } from './validateWorkTimeEntryBreaks';
import { validateWorkTimeEntryDates } from './validateWorkTimeEntryDates';

export function validateWorkTimeEntry(
  workTimeEntry: WorkTimeEntryToCreate
): ValidationFn {
  return ValidationUtils.combine([
    validateWorkTimeEntryDates(workTimeEntry),
    validateWorkTimeEntryBreaks(workTimeEntry)
  ]);
}
